<template>
  <div class="tw-text-center">
    <h2 class="tw-text-2xl tw-mb-8 tw-font-semibold">
      Let's make your account more secure
    </h2>
    <p class="tw-mb-4">
      Two-factor authentication adds an extra layer of protection to your account.
    </p>
    <p>Please follow the steps to configure Two-factor Authentication with your mobile App.</p>
  </div>
</template>
